module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bodyLotion_b09383.png";